
import { ACTIONS } from '../../constants';
import * as api from '../../api';

// ---------------------------------------------------
// Category
// ---------------------------------------------------

export const fetchCategoryData = categoryId => ({
  type: ACTIONS.CHANGE_CATEGORY,
  categoryId,
  data: api.getCategoryData(categoryId),
});

export const resetCategoryData = () => ({
  type: ACTIONS.CHANGE_CATEGORY,
  categoryId: '',
  data: [],
});

export const changeTopic = topic => ({
  type: ACTIONS.CHANGE_TOPIC,
  topic,
});

export const changeSubtopic = subtopic => ({
  type: ACTIONS.CHANGE_SUBTOPIC,
  subtopic,
});

export const changeCategorySorting = sorting => ({
  type: ACTIONS.CHANGE_SORTING,
  sorting,
});

// ---------------------------------------------------
// Detail
// ---------------------------------------------------

export const detailActive = isActive => ({
  type: ACTIONS.DETAIL_ACTIVE,
  isActive,
});

// todo - revise with whole "modal detail" stuff - maybe not ideal
export const saveLastLocation = lastLocation => ({
  type: ACTIONS.SAVE_LAST_LOCATION,
  lastLocation,
});

export const detailIntroPlayed = category => ({
  type: ACTIONS.DETAIL_INTRO_PLAYED,
  category,
});

// ---------------------------------------------------
// Resize
// ---------------------------------------------------

export const gridUpdate = grid => ({
  type: ACTIONS.RESIZE_GRID,
  grid,
});

export const widthUpdate = width => ({
  type: ACTIONS.RESIZE_WIDTH,
  width,
});

export const menuOverlayUpdate = menuOverlay => ({
  type: ACTIONS.MENU_OVERLAY,
  menuOverlay,
});

export const showUpBtnUpdate = showUpBtn => ({
  type: ACTIONS.SHOW_UP_BTN,
  showUpBtn,
});

export const menuSwitch = () => ({
  type: ACTIONS.MENU_SWITCH,
});



// WEBPACK FOOTER //
// ./src/redux/actions/index.js